/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dispatch_Patrol_Places_LabelInputs */

const en_dispatch_patrol_places_label = /** @type {(inputs: Dispatch_Patrol_Places_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stops (≥ 2)`)
};

const fr_dispatch_patrol_places_label = /** @type {(inputs: Dispatch_Patrol_Places_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Étapes (≥ 2)`)
};

const ms_sg2_dispatch_patrol_places_label = /** @type {(inputs: Dispatch_Patrol_Places_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hentian (≥ 2)`)
};

/**
* | output |
* | --- |
* | "Stops (≥ 2)" |
*
* @param {Dispatch_Patrol_Places_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const dispatch_patrol_places_label = /** @type {((inputs?: Dispatch_Patrol_Places_LabelInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dispatch_Patrol_Places_LabelInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dispatch_patrol_places_label(inputs)
	if (locale === "fr") return fr_dispatch_patrol_places_label(inputs)
	return ms_sg2_dispatch_patrol_places_label(inputs)
});